import { render, staticRenderFns } from "./kdpsuccess.vue?vue&type=template&id=e338b7b6"
import script from "./kdpsuccess.vue?vue&type=script&lang=js"
export * from "./kdpsuccess.vue?vue&type=script&lang=js"
import style0 from "./kdpsuccess.vue?vue&type=style&index=0&id=e338b7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports